
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profil",
      function () {
        return require("private-next-pages/profil/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profil"])
      });
    }
  